<template>
	<div class="page_centernews">
		<el-button style="position: absolute; right: 30px; top: 7px" type="primary" size="mini" round @click="addOne">我要投稿</el-button>
		<div v-if="$route.name !== 'serviceDetail'" v-loading="loading">
			<ul class="list">
				<li v-for="(v, i) in list" :key="i" @click="$router.push({ name: 'serviceDetail', query: { id: v.id } })">
					<span class="title" :title="v.title">{{ v.title }}</span>
					<span class="time">{{ v.createTime | formatDate }}</span>
				</li>
			</ul>
			<page v-if="list.length > 0" :total="total" :currentPage="currentPage" :pageSize="pageSize" v-on:pagination="getList"></page>
		</div>
		<div class="details" v-else>
			<router-view :key="$route.fullPath"></router-view>
		</div>
	</div>
</template>

<script>
import page from '@/components/Pagination/index.vue'
import { formatdate } from '@/utils/index'
export default {
	components: {
		page,
	},
	data() {
		return {
			list: [],
			total: 0,
			currentPage: 1,
			pageSize: 10,
			loading: false,
		}
	},
	filters: {
		formatDate(time) {
			var date = new Date(time)
			return formatdate(date, 'yyyy-MM-dd hh:mm:ss')
		},
	},
	created() {
		this.getList({
			page: 1,
			limit: this.pageSize,
		})
	},
	computed: {
		loginVisible: {
			get() {
				return this.$store.state.loginVisible
			},
			set(val) {
				this.$store.commit('updateLoginVisible', val)
			},
		},
	},
	methods: {
		addOne() {
			let token = this.$cookie.get('X-Web-Token')
			if (!token) {
				this.loginVisible = true
				return
			}
			this.$router.push('/serviceAdd')
		},
		getList(obj) {
			this.loading = true
			this.$http
				.post(this.$api.systemApi.techList, {
					current: obj.page,
					size: obj.limit,
					data: {
						type: 'JSXQ',
					},
				})
				.then(({ data }) => {
					this.loading = false
					this.list = data.data.list || []
					this.total = data.data.total || 0
				})
				.catch(() => {
					this.loading = false
					this.list = []
					this.total = 0
				})
		},
	},
}
</script>

<style lang="scss" scoped>
.page_centernews {
	.list {
		li {
			display: flex;
			align-items: center;
			justify-content: space-between;
			height: 40px;
			line-height: 40px;
			padding: 0 16px;
			margin-bottom: 8px;
			background: #f7f7f7;
			border-radius: 8px;
			cursor: pointer;

			&:hover {
				opacity: 0.8;
			}

			.news_title {
				flex: 1;
			}

			.time {
				color: #999999;
			}
		}
		.title {
			width: 82%;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}
}
</style>
